/**
 * Subtracts a value from the current value.
 *
 * @param {number|string} x - Current value.
 * @param {number|string} y - Value to be subtracted.
 * @returns {number}
 */
export function subtract(x, y) {
  return Number(x) - Number(y);
}
